class User {
  constructor(token, id, email, firstName, lastName, subscriptions = {}) {
    this.token = token;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.id = id;
    this.profile = null;
    this.subscriptions = subscriptions;
  }

  setProfile(profile = null) {
    this.profile = profile;
  }
}

export default User;
